import { useCallback, useEffect, useState } from "react";
import { Row, Select, Spin, Input, Statistic} from "antd";

import { useHistory } from "react-router-dom";
import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloseOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { EstagioService } from "../../services/estagio.service";

import { TableEstagio } from "../../components/table/estagio";
import { Wrapper } from "./styles";

import { ExportCSV } from "../estagioBusca/components/exportCSV";
// import { Container, Row, Col } from 'reactstrap';

export function EstagioBusca() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [cursoSelected, setCursoSelected] = useState("TODOS");
  const [statusSelected, setStatusSelected] = useState("TODOS");

  const [lista, setLista] = useState({
    data: [],
    totalElements: 0,
  });
  const [state, setState] = useState({
    page: 1,
    size: 15,
    nome: null,
  });
  const [listaCursos, setListaCursos] = useState({});
  const [cpfNumb, setCpfNumb] = useState("");
  const update = useCallback(
    (newValues) => setState((prev) => ({ ...prev, ...newValues })),
    []
  );
  const statusList = ["DEFERIDO", "INDEFERIDO", "INSCRITO", "TODOS"];

  useEffect(() => {
    buscalistaCompleta("TODOS");
  }, []);

  const buscalistaCompleta = async (status) => {
    try {
      setLoading(true);
      // const {page, size, nome} = state;

      // fetch('https://spca.sspds.ce.gov.br/prod/api/portal/estagio/allSemAnexos', {
      //   method: 'GET',
      //   headers: new Headers({
      //     'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzgzMzA1OTgsImlhdCI6MTYzMzUzMDU5OCwiaW50ZXJuYWxJZCI6ODQ2NywiZXh0ZXJuYWxJZCI6ODM2MiwiYXBwU2VydmVyS2V5IjoiYTk0OWYyNGZlZjhhNzVhYzJlZWZmNzY0Yzk0NGRmOGMiLCJ0eXBlQ2xpZW50IjoidXNlciIsInR5cGVUb2tlbiI6ImRlZmF1bHQiLCJ0b2tlbk51bWJlciI6MSwicm9sZXMiOlsiUk9MRV9TU0FfU0lQM1ciLCJST0xFX1NTQV9JTlRFTElHRU5DSUFfQ09JTiIsIlJPTEVfU1NBX0VYRUNVVElWTyIsIlJPTEVfU1NBX0NPVElDIiwiUk9MRV9TU0FfSU5URUxJR0VOQ0lBX0RJUCIsIlJPTEVfU1NBX0lOVEVMSUdFTkNJQV9BU0lOVCIsIlJPTEVfU1NBX0lOVEVMSUdFTkNJQV9BU1NJTlQiLCJST0xFX1NTQV9FU1RBR0lPIl19.pHA7a_9HpCLEwBhL_py2Y6Sgj__Y0FfQAlDriSMaNaU',
      //     'Content-Type': 'application/json'
      //   }),
      // }).then(response => response.json())
      // .then(data => console.log("FETCHHHH", data));
      await EstagioService.getAll().then(({ data }) => {
        // console.log("Status", status);
        if (status === "INSCRITO") {
          data = data.filter(
            (ficha) =>
              ficha["situacao"] !== "DEFERIDO" &&
              ficha["situacao"] !== "INDEFERIDO"
          );
        } else if (status !== "TODOS") {
          data = data.filter((ficha) => ficha["situacao"] === status);
        }


        // console.log("Estagiarios .........", data);
        setLista({
          data: upper(data.sort(GetSortOrder("nome"))),
          // totalElements: data.totalElements
        });
        // console.log("lista" + JSON.stringify(lista.totalElements));
      });
    } catch {
      console.log("Falha ao recuperar lista de estagiários");
    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        // setLoading(true);
        await EstagioService.getAllCursos().then(({ data }) => {
          // console.log("Cursos ", data);
          // data = data
          setListaCursos({ ...data, TODOS: "TODOS" });
        });
      } catch {
        console.log("Falha o recuperar cursos");
      } finally {
        // setLoading(false);
      }
    };

    load();
  }, []);

  const buscaCurso =  async(curso, status) =>{
    setCursoSelected(curso);
    try {
      setLoading(true);
      if (curso === "TODOS") {
       await EstagioService.getAll().then(({ data }) => {
          //console.log("Cursos " + JSON.stringify(data));
          if (status === "INSCRITO") {
            data = data.filter(
              (ficha) =>
                ficha["situacao"] !== "DEFERIDO" &&
                ficha["situacao"] !== "INDEFERIDO"
            );
          } else if (status !== "TODOS") {
            data = data.filter((ficha) => ficha["situacao"] === status);
          }

          setLista({
            data: upper(data.sort(GetSortOrder("nome"))),
            // totalElements: data.totalElements
          });
        });
      } else {
        await EstagioService.findByCurso(curso).then(({ data }) => {
          //console.log("Cursos " + JSON.stringify(data));
          if (status !== "TODOS") {
            if (status === "INSCRITO") {
              data = data.filter((ficha) =>
                ficha["situacao"] ? ficha["situacao"] === status : true
              );
            } else {
              data = data.filter((ficha) => ficha["situacao"] === status);
            }
          }
          setLista({
            data: upper(data.sort(GetSortOrder("nome"))),
            // totalElements: data.totalElements
          });
        });
      }
    } catch {
      console.log("Erro ao recuperar cursos");
    } finally {
      setLoading(false);
    }

    //console.log(curso);
  }

  const cpfMask = (value) => {
    return value
      .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
  };

  function upper(obj) {
    for (var prop in obj) {
      if (typeof obj[prop] === "string") {
        obj[prop] = obj[prop].toUpperCase();
      }
      if (typeof obj[prop] === "object") {
        upper(obj[prop]);
      }
    }
    return obj;
  }

  function GetSortOrder(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    };
  }

  function handlechangeCpf(e) {
    setCpfNumb(cpfMask(e.target.value));
  }
  
  

  function formatDate (input) {
    // console.log("inp", input)
    var ano  = (typeof input.split("-")[0] === 'undefined')? "" : input.split("-")[0];
    var mes  = (typeof input.split("-")[1] === 'undefined')? "" : input.split("-")[1];
    var dia  = (typeof input.split("-")[2] === 'undefined')? "" : input.split("-")[2];
    if (ano === "" || dia === "" || mes === ""){
      return (`${dia}${mes}${ano}`);
    } 
    return (`${dia}/${mes}/${ano}`);
  }

  function preparaExport(data) {
    // console.log(data)
    const transformed = Object.create(data)
    // console.log("trans", transformed);
    // transformed.forEach( obj => renameKey( obj, 'dataNascimento', 'Data Nascimento' ) );
    var date
     transformed.map((item) => {
      delete item["estadoCivil"];
      delete item["nomeMae"];
      delete item["nomePai"];
      delete item["complemento"];
      delete item["cep"];
      delete item["endereco"];
      delete item["dataCriacao"];
      delete item["bairro"];
      delete item["genero"];
      delete item["numero"];
      delete item["deficiente"];
      delete item["turnoCurso"];
      item["situacao"] = item.situacao
      ? item.situacao
      : "INSCRITO";
      date = formatDate(item.dataNascimento);
      // console.log(date);

      item["dataNascimento"] = date;
      return item;


    })
    return transformed;
    
  }

  function buscaListaPorStatus(status) {
    // console.log(status);
    setStatusSelected(status);
    if (cursoSelected === "TODOS") {
      //console.log("Nenhum Curso");
      buscalistaCompleta(status);
    } else {
      console.log("Curso ", cursoSelected);
      buscaCurso(cursoSelected, status);
    }

    // console.log(lista.data);
    // var newData = lista.data.filter((ficha) =>ficha["situacao"]===status);
    // setLista({
    //   data: upper(newData.sort(GetSortOrder("nome"))),
    //   // totalElements: data.totalElements
    // });
    // try{

    //   EstagioService.getBySituacao(status).then(({data}) => {

    //     setLista({
    //       data: upper(data.sort(GetSortOrder("nome"))),
    //       // totalElements: data.totalElements
    //     });

    //   })

    // }
    // catch{

    // }
  }

  function countDeferidos() {
    return lista.data.filter((ficha) => ficha["situacao"] === "DEFERIDO")
      .length;
  }
  function countInDeferidos() {
    return lista.data.filter((ficha) => ficha["situacao"] === "INDEFERIDO")
      .length;
  }
  function countInscritos() {
    return lista.data.filter(
      (ficha) => ficha["situacao"] === "INSCRITO" || ficha["situacao"] === null
    ).length;
  }

  // console.log(loading);
  return (
    <Spin spinning={loading}>
      <Wrapper>
        <Row>
          <ArrowLeftOutlined
            onClick={() => history.goBack()}
            style={{ fontSize: "16px", marginRight: 10, marginTop: 10 }}
          />
          <h1>Busca Estagiários</h1>
        </Row>
        
        <div className="cardFiltroEstagiarios">
        <div className = "cardsEstatistic">

          <div className="filtroEstatistica">
            <Statistic
              // style={{ width: "100%" }}
              title=" INSCRITOS "
              value={countInscritos()}
              // precision={2}
              valueStyle={{ color: "gray" }}
              prefix={<UserOutlined />}
              // suffix="%"
            />

          </div>
          <div className="filtroEstatistica">

            <Statistic
              title="DEFERIDOS"
              value={countDeferidos()}
              // precision={2}
              valueStyle={{ color: "#3f8600" }}
              prefix={<CheckOutlined />}
              // suffix="%"
            />

          </div>
          <div className="filtroEstatistica">
        
            <Statistic
              title="INDEFERIDOS"
              value={countInDeferidos()}
              // precision={2}
              valueStyle={{ color: "orange" }}
              prefix={<CloseOutlined />}
              // suffix="%"
            />
            </div>
          </div>


          <div className="filtroEstagiarios">
            <Input.Search
            className = "input-cpf"
              allowClear
              // style={{ width: '40%' }}
              placeholder={"Buscar por CPF"}
              onSearch={(value) => {
                history.push(
                  `/detalhesEstagio/` +
                    cpfNumb.replaceAll(".", "").replaceAll("-", "")
                );
              }}
              onChange={handlechangeCpf}
              value={cpfNumb}
            />
            <Select
              // className="container-dropdown"
              // style={{ minWidth: "100%" }}
              placeholder="Selecione o Curso"
              onChange={(curso) => buscaCurso(curso, statusSelected)}
            >
              {Object.entries(listaCursos).map((curso, index) => {
                return (
                  <Select.Option key={index} value={curso[0]}>
                    {curso[1]}
                  </Select.Option>
                );
              })}
            </Select>

            <Select
              // className="container-dropdown"
              // style={{ minWidth: "100%" }}
              // style={{ minWidth: "40%" }}
              placeholder="Selecione o Status"
              onChange={(status) => buscaListaPorStatus(status)}
            >
              {statusList.map((status, index) => {
                return (
                  <Select.Option key={index} value={status}>
                    {status}
                  </Select.Option>
                );
              })}
            </Select>
          </div>

        </div>
        
        <br />
        <br />

        <TableEstagio
          loading={loading}
          data={lista.data}
          // totalElements={lista.totalElements}
          page={state.page}
          size={state.size}
          // module="asint"
          onChangePage={(page) => update({ page })}
        />
        <div className="areaExport">
          <ExportCSV
            csvData={preparaExport(lista.data)}
            fileName={"Lista_Estagiarios"}
          />
        </div>
      </Wrapper>
    </Spin>
  );
}
